const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'keystone_investor_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

async function request(path, init = {}) {
  const headers = { 'Content-Type': 'application/json', ...(init.headers || {}) };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(`${API}${path}`, { ...init, headers });
  if (res.status === 401) {
    clearToken();
    throw new Error('Session expired — please sign in again.');
  }
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try { const d = await res.json(); msg = d.detail || d.message || msg; } catch {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const requestAccess = (payload) =>
  request('/api/investors/request-access', { method: 'POST', body: JSON.stringify(payload) });

export const login = async (email, password) => {
  const res = await request('/api/investors/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  setToken(res.token);
  return res;
};

export const me = () => request('/api/investors/me');
export const getContent = () => request('/api/investors/portal/content');
export const getKpis = () => request('/api/investors/portal/kpis');
export const getDocuments = () => request('/api/investors/portal/documents');
export const trackDocument = (id) =>
  request(`/api/investors/portal/documents/${id}/track`, { method: 'POST' });
